import React from 'react'
import FormNavigationButtons from './FormNavigationButtons'
import { IpsaMoneyField } from './Form/IpsaFormattedFields'
import IpsaTextField from './Form/IpsaTextField'
import { useFormikContext } from 'formik'

import { InsuredAsset } from '../../../variables/InitialValues'

import RenderFieldArray from 'components/RenderFieldArray/RenderFieldArray'

const RenderInsuredAsset = ({ index }) => (
    <>
        <div className="col-xs-12 col-md-3">
            <IpsaTextField name={`assets.${index}.name`} type="text" label="Asset Name" />
        </div>
        <div className="col-xs-12 col-md-3">
            <IpsaMoneyField
                name={`assets.${index}.estimatedValue`}
                type="text"
                label="Estimated Value"
            />
        </div>
        <div className="col-xs-12 col-md-3">
            <IpsaMoneyField
                values={['Yes', 'No']}
                name={`assets.${index}.annualInsuranceCost`}
                label="Estimated Annual Premium"
            />
        </div>
    </>
)

const InsuredAssetsStep = ({ clientId, onSave }) => {
    const { values } = useFormikContext()
    const { assets } = values

    return (
        <>
            <div id="new-client-1" className="new-client-form animated-form">
                <h2>Insured Assets</h2>
                <RenderFieldArray
                    field="assets"
                    values={assets}
                    newItem={InsuredAsset}
                    allowZero
                    inline
                >
                    <RenderInsuredAsset />
                </RenderFieldArray>
            </div>
            <FormNavigationButtons
                section="assets"
                previous="coverage"
                next="protections"
                clientId={clientId}
                onSave={onSave}
            />
        </>
    )
}

export default InsuredAssetsStep
